import Holidays from "../../assets/holidays.json"
import HolidaysIRV1 from "../../assets/holidays-irv1.json"
export default {
  data() {
    return {
      hours: [
        '00:00', // 0
        '00:30', // 1
        '01:00', // 2
        '01:30', // 3
        '02:00', // 4
        '02:30', // 5
        '03:00', // 6
        '03:30', // 7
        '04:00', // 8
        '04:30', // 9
        '05:00', // 10
        '05:30', // 11
        '06:00', // 12
        '06:30', // 13
        '07:00', // 14
        '07:30', // 15
        '08:00', // 16
        '08:30', // 17
        '09:00', // 18
        '09:30', // 19
        '10:00', // 20
        '10:30', // 21
        '11:00', // 22
        '11:30', // 23
        '12:00', // 24
        '12:30', // 25
        '13:00', // 26
        '13:30', // 27
        '14:00', // 28
        '14:30', // 29
        '15:00', // 30
        '15:30', // 31
        '16:00', // 32
        '16:30', // 33
        '17:00', // 34
        '17:30', // 35
        '18:00', // 36
        '18:30', // 37
        '19:00', // 38
        '19:30', // 39
        '20:00', // 40
        '20:30', // 41
        '21:00', // 42
        '21:30', // 43
        '22:00', // 44
        '22:30', // 45
        '23:00', // 46
        '23:30', // 47
        '24:00' // 48
      ],
      holidays: Holidays,
      holidaysIrv1: HolidaysIRV1
    }
  },
  methods: {
    calculateHours(day, startHour, endHour) {
      let normal = 0;
      let overtime = 0;
      let holiday = 0;
      let total = 0;
      const startIndex = this.hours.indexOf(startHour)
      const endIndex = this.hours.indexOf(endHour)

      if (day && startHour && endHour) {
        const date = new Date(day)
        // Determine if it's holiday from the predefined array of days
        const isHoliday = this.holidays.indexOf(`${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}`) > -1;
        const isIRV1 = this.holidaysIrv1.indexOf(`${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}`) > -1;
        // Saturday or Sunday
        const isWeekend = date.getDay() === 0 || date.getDay() === 6;

        if (isHoliday && !isIRV1) {
          for (let i = startIndex; i < endIndex; i++) {
            if (i !== 24 && i !== 25) {
              holiday += 0.5;
              total += 0.5;
            }
          }
        } else {
          if (isWeekend || isIRV1) {
            // loop trough hours from start to end
            for (let i = startIndex; i < endIndex; i++) {
              if (i !== 24 && i !== 25) {
                overtime += 0.5;
                total += 0.5;
              }
            }
          } else {
            // loop trough hours from start to end
            for (let i = startIndex; i < endIndex; i++) {
              // NORMAL WORKING TIME
              // index 16 = 08:00 (start from 08:00)
              // index 24 = 12:00
              // index 25 = 12:30 (start from 13:00)
              // index 34 = 17:00
              if (i > 15 && i < 34) {
                // IF NOT LUNCH
                if (i !== 24 && i !== 25) {
                  normal += 0.5;
                }
              }
              // EVERYTHING ELSE IS OVERTIME
              else {
                overtime += 0.5;
              }

              // IF NOT LUNCH
              if (i !== 24 && i !== 25) {
                total += 0.5;
              }
            }
          }
        }
      }

      return {
        normal: normal,
        overtime: overtime,
        holiday: holiday,
        total: total
      }
    }
  }
}